import React, { useState, useEffect } from 'react';
import { Card, Button } from "react-bootstrap";
import Footer from '../common/footer';
import { FaRegTimesCircle } from 'react-icons/fa';
import logoEs from '../../assets/myReportin-canal-de-denuncias.png';
import logoCa from '../../assets/myreportin_catalan_positivo.png';
import logoEu from '../../assets/myreportin_euskera_positivo.png';
import logoGa from '../../assets/myreportin_gallego_positivo.png';
import logoEn from '../../assets/myreportin_ingles_positivo.png';
import logoIt from '../../assets/myreportin_italiano_positivo.png';
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";

const logos = {
    es: logoEs,
    ca: logoCa,
    eu: logoEu,
    ga: logoGa,
    en: logoEn,
    it: logoIt,
};

export const AccessDenied = () => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const location = useLocation();
    const itemData = location.state?.companyData;
    const fullURL = location.state?.fullURL;
    const newURL = fullURL?.replace('createIncident', 'publicIncident');
    const [t, i18n] = useTranslation("accessDenied")
    const currentLanguage = i18n.language;


    return (
        <div className='width-95 m-auto'>
            <div className="access-denied-container">
                <Card className="custom-shadow common-card-card access-denied-card">
                    <Card.Body>
                        <div className="access-denied-main-container">
                            <img
                                src={itemData ? `data:${itemData.imageMimeType};base64,${itemData.imageData}` : logos[currentLanguage] || logoEs}
                                className='access-denied-company-img'
                                onLoad={() => setImageLoaded(true)}
                                style={{
                                    cursor: "pointer",
                                    opacity: imageLoaded ? 1 : 0,
                                    transition: 'opacity 0.3s'
                                }}
                            />

                        </div>

                        <div className="access-denied-title font-bold">
                            {itemData ? `${t("accessDenied.pageNotAvailable")}` : `${t("accessDenied.accessDenied")}`}
                        </div>

                        <div className="access-denied-main-container">
                            <FaRegTimesCircle className='access-denied-icon' />
                        </div>

                        <div className="access-denied-text mt-4">
                            {
                                itemData ?
                                    `${t("accessDenied.pageNotAvailableText")}`
                                    :
                                    `${t("accessDenied.accessDeniedText")}`

                            }
                        </div>

                        <div className="access-denied-main-container">
                            <Button
                                type="submit"
                                className="w-50 mt-3 custom-button-primary custom-bg-primary"
                                onClick={() => {
                                    itemData ?
                                        window.location.href = newURL
                                        :
                                        window.location.href = "/legal"
                                }}
                            >
                                {t("accessDenied.return")}
                            </Button>
                        </div>

                    </Card.Body>


                </Card>

            </div>
            {itemData ?
                null
                :
                <Footer />
            }
        </div>

    )
}